import React, { useState, useEffect } from 'react';
import { Card, Layout, Select, Input, Button } from 'element-react';

const FilterHeader = ({ 
    filterCerts, setFilterCerts, sortBy, setSortBy, t, 
    activeTab, onSearch 
}) => {

    const [localCert, setLocalCert] = useState(filterCerts);

    useEffect(() => {
        setLocalCert(filterCerts);
    }, [filterCerts])

    const handleClicked = () => {
        setFilterCerts(localCert);
        if (onSearch) onSearch();
    }

    // === CASO 1: VISTA DE EMPRESAS ===
    if (activeTab === 'companies') {
        return (
            <div className="filter-header">
                <Card className="box-card">
                    <Layout.Row type="flex" className="filter-header-layout" span="24">
                        
                        {/* --- COLUMNA IZQUIERDA: AHORA ES FILTRO CERTIFICACIÓN --- */}
                        <Layout.Col className="filter-header-margin" offset="1" xs="24" sm="22" md="22" lg="12">
                            <Layout.Row type="flex" span="24">
                                <Layout.Col className="result-min-order filter-spacer" xs="24" sm="22" md="22" lg="22">
                                    Filter results by a certification:
                                </Layout.Col>
                            </Layout.Row>    
                            <Layout.Row type="flex" span="24">
                                <Layout.Col tag="form-button-inverse" className="filter-spacer" xs="24" sm="22" md="22" lg="22">
                                    <div style={{display: 'inline-flex'}} className="filter-spacer">
                                        <Input value={localCert} onChange={v => setLocalCert(v)} placeholder="ISO 9001..." className="filter-spacer"/>
                                        <Button onClick={handleClicked} style={{ width: '160px', height: '40px', marginTop: '3px' }} type="primary">
                                            Filter
                                        </Button>
                                    </div>
                                </Layout.Col>
                            </Layout.Row>    
                        </Layout.Col>

                        {/* --- SEPARADOR VERTICAL (en medio) --- */}
                        <Layout.Col className="gray-rigth-separator" offset="1" xs="24" sm="2" md="2" lg="4">
                        </Layout.Col>

                        {/* --- COLUMNA DERECHA: AHORA ES SORT BY --- */}
                        <Layout.Col style={{display: 'none'}} className="filter-header-margin" offset="1" xs="24" sm="22" md="22" lg="10">
                            <Layout.Row type="flex" span="24">
                                <Layout.Col className="result-price filter-spacer" xs="24" sm="22" md="22" lg="22">
                                    {t('search.sort-by') || "Sort by"}:
                                </Layout.Col>
                            </Layout.Row>    
                            <Layout.Row type="flex" span="24">
                                <Layout.Col className="filter-spacer" xs="24" sm="22" md="22" lg="22">
                                    <Select value={sortBy} onChange={v => { setSortBy(v); if(onSearch) onSearch(); }} placeholder="Most relevant" style={{ width: '100%' }}>
                                        <Select.Option label="Most relevant" value="relevant" />
                                        <Select.Option label="Name (A-Z)" value="name_asc" />
                                        <Select.Option label="Name (Z-A)" value="name_desc" />
                                    </Select>
                                </Layout.Col>
                            </Layout.Row>
                        </Layout.Col>

                    </Layout.Row>
                </Card>
            </div>
        );
    }

    // === CASO 2: VISTA DE PRODUCTOS (Default) ===
    return (
        <div className="filter-header">
            <Card className="box-card">
                <Layout.Row type="flex" className="filter-header-layout" span="24">
                    
                    {/* --- COLUMNA IZQUIERDA: AHORA ES FILTRO CERTIFICACIÓN --- */}
                    <Layout.Col className="filter-header-margin" offset="1" xs="24" sm="22" md="22" lg="12">
                        <Layout.Row type="flex" span="24">
                            <Layout.Col className="result-min-order filter-spacer" xs="24" sm="22" md="22" lg="22">
                                {t('search.filter-message')}:
                            </Layout.Col>
                        </Layout.Row>    
                        <Layout.Row type="flex" span="24">
                            <Layout.Col tag="form-button-inverse" className="filter-spacer" xs="24" sm="22" md="22" lg="22">
                                <div style={{display: 'inline-flex'}} className="filter-spacer">
                                    <Input value={localCert} onChange={v => setLocalCert(v)} className="filter-spacer"/>
                                    <Button onClick={handleClicked} style={{width: '160px', height: '40px', marginTop: '3px'}} type="primary">{t('search.button-filter')}</Button>
                                </div>
                            </Layout.Col>
                        </Layout.Row>    
                    </Layout.Col>

                    {/* --- SEPARADOR --- */}
                    <Layout.Col className="gray-rigth-separator" offset="1" xs="24" sm="2" md="2" lg="4">
                    </Layout.Col>
                    
                    {/* --- COLUMNA DERECHA: AHORA ES SORT BY --- */}
                    <Layout.Col className="filter-header-margin" offset="1" xs="24" sm="22" md="22" lg="10">
                        <Layout.Row type="flex" span="24">
                            <Layout.Col className="result-price filter-spacer" xs="24" sm="22" md="22" lg="22">
                                {t('search.sort-by')}:
                            </Layout.Col>
                        </Layout.Row>    
                        <Layout.Row type="flex" span="24">
                            <Layout.Col className="filter-spacer" xs="24" sm="22" md="22" lg="22">
                                <Select value={sortBy} onChange={v => setSortBy(v)} style={{ width: '100%' }}>
                                    <Select.Option label={t('search.sort.option1')} value=""/>
                                    <Select.Option label={t('search.sort.option2')} value="min-price"/>
                                    <Select.Option label={t('search.sort.option3')} value="max-price"/>
                                </Select>
                            </Layout.Col>
                        </Layout.Row>
                    </Layout.Col>

                </Layout.Row>
            </Card>
        </div>
    );
};

export default FilterHeader;